import { render, staticRenderFns } from "./Sprints.pug?vue&type=template&id=19d9e3e6&lang=pug&external"
import script from "./Sprints.js?vue&type=script&lang=js&external"
export * from "./Sprints.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports